export default class JsonApiObject {
    protected id: string | null = null
    protected type: string | null = null
    protected relationships: { [key: string]: any } = {}
    protected links: { [key: string]: string } = {}
    protected attributes: { [key: string]: any } = {}

    public constructor(data: any = null) {
        if (data != null) {
            this.setData(data)
        }
    }

    static restore(data) {
        let obj = new JsonApiObject()
        Object.assign(obj, data)
        return obj
    }

    public setData(object: any) {
        this.id = object.id
        this.type = object.type
        this.attributes = object.attributes
        this.relationships = object.relationships || {}
        this.links = object.links || {}
    }

    public link(key: string) {
        return this.links[key] || null
    }

    public setRelation(key: string, obj: JsonApiObject | JsonApiObject[]) {
        this.relationships[key] = obj
    }

    public constraints(attribute: string) {
        return this.attributes.constraints[attribute] || null
    }

    public constraint(attribute: string, constraint: string) {
        return this.attributes.constraints[attribute][constraint] || null
    }

    public writable(attribute: string): boolean {
        return this.attributes.constraints[attribute] &&
            this.attributes.constraints[attribute].hasOwnProperty('writable')
            ? this.attributes.constraints[attribute]['writable']
            : true
    }

    public authorized(attribute: string): boolean {
        return this.attributes.constraints[attribute] &&
            this.attributes.constraints[attribute].hasOwnProperty('authorized')
            ? this.attributes.constraints[attribute]['authorized']
            : true
    }

    public permissions(): Array<string> {
        return this.attributes.hasOwnProperty('permissions') ? this.attributes.permissions : []
    }

    public toIdObject(): any {
        let obj: any = { type: this.type }
        if (this.id) obj.id = this.id
        return obj
    }

    public attribute(key: string) {
        return this[key]
    }

    public setAttribute(key: string, value: any) {
        this[key] = value
        return this
    }

    public pushAttribute(key: string, value: any) {
        if (Array.isArray(this[key])) {
            this[key].push(value)
        } else {
            this[key] = [value]
        }
    }
}
